import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { filter, map, shareReplay, startWith, switchMap } from 'rxjs/operators';

import { RootState } from '@root/app.state';
import { selectUser } from '@platform/platform.selectors';
import { TaskOverview } from '@apps/fiduciary/fiduciary.state';
import moment from 'moment';
import { NavigationService } from '@platform/shared/navigation.service';
import { TasksService } from '@apps/fiduciary/tasks/tasks.service';
import { LoadingService, provideLoadingService } from '@platform/shared/loading.service';

@Component({
  selector: 'app-task-widget',
  templateUrl: './task-widget.component.html',
  styleUrls: ['./task-widget.component.scss'],
  providers: [provideLoadingService()],
  standalone: false,
})
export class TaskWidgetComponent implements OnInit {
  @Input({ required: true }) customerSpaceId!: string;

  readonly displayRowsCount = 6;
  showAll$: Observable<boolean> = of(false);

  tasks$: Observable<TaskOverview[]>;

  private userId$: Observable<string>;

  constructor(
    private store$: Store<RootState>,
    public navigation: NavigationService,
    public loadingService: LoadingService,
    private tasksService: TasksService,
  ) {}

  get navigateLink() {
    return ['/', 'customer-spaces', this.customerSpaceId, 'fiduciary', 'tasks'];
  }

  ngOnInit(): void {
    const top = 25;

    this.userId$ = this.store$.select(selectUser).pipe(
      filter((x) => x.data !== null),
      map((u) => u.data.id),
    );

    const getTasks$ = this.tasksService
      .getPortalTasks(this.customerSpaceId, true, false, ['Open', 'InProgress'], 'NotCompleted', top)
      .pipe(shareReplay(1));

    this.tasks$ = this.userId$.pipe(
      startWith([]),
      filter((u) => !!u),
      switchMap(() => getTasks$),
    );
    this.showAll$ = this.tasks$.pipe(map((tasks) => tasks.length > this.displayRowsCount));
  }

  public isOverdue(taskDate: Date): boolean {
    const dateTask = moment(taskDate);
    const datenNow = moment(new Date().setHours(0, 0, 0, 0));
    return moment(datenNow).isAfter(dateTask);
  }
}
